import { render, staticRenderFns } from "./LegacyContextK.vue?vue&type=template&id=15dcc091&"
import script from "./LegacyContextK.vue?vue&type=script&lang=js&"
export * from "./LegacyContextK.vue?vue&type=script&lang=js&"
import style0 from "./LegacyContextK.vue?vue&type=style&index=0&id=15dcc091&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports